var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 7.71875L11.6875 11.7188C11.3125 12.125 10.6562 12.125 10.2812 11.7188C9.875 11.3438 9.875 10.6875 10.2812 10.3125L12.5625 8H6C5.4375 8 5 7.5625 5 7C5 6.46875 5.4375 6 6 6H12.5625L10.2812 3.71875C9.875 3.34375 9.875 2.6875 10.2812 2.3125C10.6562 1.90625 11.3125 1.90625 11.6875 2.3125L15.6875 6.3125C16.0938 6.6875 16.0938 7.34375 15.6875 7.71875ZM5 2H3C2.4375 2 2 2.46875 2 3V11C2 11.5625 2.4375 12 3 12H5C5.53125 12 6 12.4688 6 13C6 13.5625 5.53125 14 5 14H3C1.34375 14 0 12.6562 0 11V3C0 1.34375 1.34375 0 3 0H5C5.53125 0 6 0.46875 6 1C6 1.5625 5.53125 2 5 2Z",
    fill: "#AEAEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout_icon.d65393f13aa45668fb0968797b01aa9a.svg";
export { ForwardRef as ReactComponent };